import { lazyWithPreload as lazy } from 'react-lazy-with-preload';

const MeterpointValidation = {
  Content: lazy(
    () =>
      import(
        'components/direct-sales/meterpoint-validation/components/MeterPointValidationContent'
      )
  ),
  Header: lazy(
    () =>
      import(
        'components/direct-sales/meterpoint-validation/components/MeterPointValidationHeader'
      )
  )
};

export default MeterpointValidation;
